<kb-main-grid>

  <div kb-grid-item-columns="12"></div>

  <h1 kb-grid-item-columns="12" kb-heading
    i18n="Global search page heading@@7681007206879196557"
  >Your search.</h1>

  <form class="indented" kb-grid-item-columns="12" kb-next-grid-row="related" kb-layout="flex" [formGroup]="searchForm">
    <kb-input
      formControlName="query"
      class="search-input"
      on="background" [standalone]="true"
      i18n-ariaLabel="search input label@@4580988005648117665" ariaLabel="Search"
      i18n-placeholder="search input placeholder@@4580988005648117665" placeholder="Search"
      type="search"
    >
      <kb-icon slot="trailer" [icon]="iconSearch" aria-hidden="true" icon-uppercase icon-center></kb-icon>
    </kb-input>
    @if (filterTypes$ | async; as filterTypes) {
      <kb-chip-set type="filter" formControlName="typeFilter" name="typeFilter">
        <kb-chip type="filter" value="">
          <ng-container i18n="search filter all button@@1616102757855967475">All</ng-container>
          <kb-icon [icon]="iconAllFilter" icon-uppercase icon-center></kb-icon>
        </kb-chip>
        @for (filterType of filterTypes; track filterType) {
          <kb-chip type="filter" [value]="filterType.value">
            {{filterTypeTranslations[filterType.value]}}
            ({{filterType.count}})
          </kb-chip>
        }
      </kb-chip-set>
    }
  </form>

  <h2 kb-grid-item-columns="12" kb-next-grid-row="related" kb-heading type="divider"
    i18n="Global search results heading@@1460318440531551596"
  >Search results</h2>

  @if (results$ | async; as results) {
    <div class="global-search-results indented" kb-grid-item-columns="8" kb-layout="flex">
      @for (result of results; track result) {
        <section class="global-search-result-item">
          <a [kbRouterOrExternalLink]="result.link" [attr.target]="result.type === resultTypes.File ? '_blank' : null" kb-layout="grid">
            <div [attr.kb-grid-item-columns]="result.picture ? 9 : 12">
              <h3 kb-heading kb-html [html]="result.title"></h3>
              <p kb-paragraph>
                @if (result.type === resultTypes.Event) {
                  {{ result.startDate | date }} - {{ result.endDate | date }}
                }
              </p>
              <kb-line-clamp lines="4" kb-paragraph>
                <kb-html [html]="result.content"></kb-html>
              </kb-line-clamp>
              <span kb-standalone-link>
                @if (result.fileSize) {
                  <ng-container i18n="download link@@3099741642167775297">Download</ng-container> ({{ result.fileSize | bytes }})
                } @else {
                  <ng-container i18n="content teaser read more link@@2827984212740060090">Read more</ng-container>
                }
              </span>
            </div>
            @if (result.picture) {
              <div kb-grid-item-columns="3">
                <kb-picture
                  [picture]="result.picture.sources"
                  [alt]="result.picture.alt"
                  [rootColumns]="2"
                ></kb-picture>
              </div>
            }
          </a>
        </section>
        <hr>
      }
      @if (loading$ | async) {
        <kb-progress-indicator
          [visible]="true"
        ></kb-progress-indicator>
      }
      @if ({ value: numResults$ | async }; as numResults) {
        @if (numResults.value !== null) {
          @if (numResults.value !== 0 && results.length < numResults.value) {
            <button kb-button (click)="preparedSearch.next()">
              <ng-container i18n="load more results button@@33149636091572968">Load more</ng-container>
              <kb-icon [icon]="iconLoadMore"></kb-icon>
            </button>
          }
          @if (numResults.value === 0) {
            <p kb-paragraph>
              <ng-container i18n="search no results text@@6562806658019188537">Your search returned no results.</ng-container>
            </p>
          }
        }
      }
    </div>
  } @else {
    @if (loading$ | async) {
      <kb-progress-indicator
        [visible]="true"
      ></kb-progress-indicator>
    }
  }

</kb-main-grid>
